var _defs, _tspan, _tspan2, _tspan3, _tspan4, _tspan5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "193.96124mm",
    height: "101.5941mm",
    viewBox: "0 0 193.96124 101.5941",
    id: "svg5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 613.06158,
    y: 229.1026,
    width: 229.80969,
    height: 79.195961,
    id: "rect38580"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.84839,
    y: 76.367531,
    width: 251.73001,
    height: 88.388344,
    id: "rect38568"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.9497476,
    y: 331.63309,
    width: 316.07672,
    height: 88.388344,
    id: "rect38556"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.5355339,
    y: 190.91882,
    width: 321.73358,
    height: 79.195961,
    id: "rect38466"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.133514,
    y: 69.296463,
    width: 269.40768,
    height: 89.095451,
    id: "rect38314"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer8",
    transform: "translate(-648.49495,-17.439098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer11",
    transform: "translate(641.14483,5.0937271)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect36077-3",
    width: 74.708328,
    height: 24.647476,
    x: 9.9960127,
    y: 14.991206
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38048",
    width: 74.708328,
    height: 24.647478,
    x: 10.270635,
    y: 50.350964
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38050",
    width: 74.708328,
    height: 24.647478,
    x: 9.9960127,
    y: 86.646164
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38052",
    width: 23,
    height: 24.64748,
    x: 102.17297,
    y: 34.261341
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38054",
    width: 23,
    height: 24.647476,
    x: 102.17297,
    y: 70.743629
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38056",
    width: 56.829842,
    height: 24.647478,
    x: 141.83577,
    y: 20.603867
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fontVariationSettings: "normal",
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#d3d3d3",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000"
    },
    id: "rect38058",
    width: 56.829842,
    height: 24.647478,
    x: 141.83577,
    y: 59.144135
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 2.64583,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 82.960512,27.748355 19.999998,20",
    id: "path38177"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 2.64583,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 82.8926,63.038505 20.06791,-15.29015 v 0",
    id: "path38248"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 2.64583,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "M 83.012571,99.894973 102.96051,84.748355",
    id: "path38250"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 2.64583,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 82.960512,27.748355 19.999998,57",
    id: "path38252"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 2.64583,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 124.09746,46.748355 19,-14.822339",
    id: "path38254"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 2.64583,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 124.09746,84.31279 19,-11.564435",
    id: "path38256"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#2f3333",
      strokeWidth: 2.64583,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 124.09746,46.748355 19,26",
    id: "path38258"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,7.6433982,1.3805974)",
    id: "text38312",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect38314)",
      display: "inline",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 43.132812,
    y: 117.95446,
    id: "tspan56926"
  }, "Twitch"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.32279933,0,0,0.26458333,18.301772,4.5407703)",
    id: "text38464",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect38466)",
      display: "inline",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 6.7901,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: -3.5351562,
    y: 239.57556,
    id: "tspan56928"
  }, "Short"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,22.979929,3.4260277)",
    id: "text38554",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect38556)",
      display: "inline",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: -4.9492188,
    y: 380.2904,
    id: "tspan56930"
  }, "Timer"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,-6.9715511,5.1019024)",
    id: "text38566",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect38568)",
      display: "inline",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 591.84766,
    y: 125.02478,
    id: "tspan56932"
  }, "Chat"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.26458333,0,0,0.26458333,-9.8044521,3.1066588)",
    id: "text38578",
    style: {
      fontSize: "53.3333px",
      fontVariationSettings: "normal",
      letterSpacing: 10,
      whiteSpace: "pre",
      shapeInside: "url(#rect38580)",
      display: "inline",
      opacity: 1,
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 613.0625,
    y: 277.7611,
    id: "tspan56934"
  }, "OBS"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScc);
export default __webpack_public_path__ + "static/media/SCC.d185a4d331231c3f2623bf571946e292.svg";
export { ForwardRef as ReactComponent };